module.exports = function getResource(label, vars = []) {
    let resources = {
        title: 'Credit Card Rewards',
        moreLink: 'More',
        listTitle: 'Credit Card Rewards Earned',
        creditCardReward: 'Credit Card Reward',
        view: 'View',
        more: 'more',
        modalButton: 'Got It'
    };

    return resources[label];
};
